import { plainToClass } from 'class-transformer';
import {
  API_PLACE_SERVICE_CREATE,
  API_PLACE_SERVICE_DELETE,
  API_PLACE_SERVICE_FIND_ALL,
  API_PLACE_SERVICE_FIND_ONE,
  API_PLACE_SERVICE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { PlaceServiceDto } from '../dto';
import { FindAllResponse } from '../types';

export class PlaceServiceApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<PlaceServiceDto>> {
    return this.httpClient
      .get(API_PLACE_SERVICE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(PlaceServiceDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<PlaceServiceDto> {
    return this.httpClient
      .get(API_PLACE_SERVICE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(PlaceServiceDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<PlaceServiceDto> {
    return this.httpClient
      .post(API_PLACE_SERVICE_CREATE, data)
      .then(({ data }) => {
        return plainToClass(PlaceServiceDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<PlaceServiceDto> {
    return this.httpClient
      .put(API_PLACE_SERVICE_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(PlaceServiceDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_PLACE_SERVICE_DELETE, {
      pathParams: { uuid }
    });
  }
}
